import { ValidatorFn } from '@angular/forms';
import { ExtendedFormControl } from '../extended-form-control.class';

export class CheckboxControl extends ExtendedFormControl {
    readonly inputType = 'checkbox';

    constructor(name: string, value: boolean = false, validations: ValidatorFn[] = [], disabled = false) {
        super(name, value, validations, disabled);
    }
}
